<template>
    <PageHeader :title="t('my.changeWithdrawPassword')" />
    <div class="page-wrapper" style="padding-top: calc(50px * 1.1)!important;">
        <div class="password-manage-container desktop-container">
            <div class="password-form">
                <div class="form-section">
                    <div class="section-title">
                        <div class="title-with-icon">
                            <span class="password-icon">🔒</span>
                            <span>{{ t('changeWithdrawPasswordPage.currentPassword') }}</span>
                        </div>
                    </div>
                    <div class="input-container">
                        <input type="password" v-model="formData.oldPassword" :placeholder="t('changeWithdrawPasswordPage.currentPasswordPlaceholder')" class="form-input">
                    </div>
                </div>
                <div class="form-section">
                    <div class="section-title">
                        <div class="title-with-icon">
                            <span class="password-icon">🔑</span>
                            <span>{{ t('changeWithdrawPasswordPage.newPassword') }}</span>
                        </div>
                    </div>
                    <div class="input-container">
                        <input type="password" v-model="formData.newPassword" :placeholder="t('changeWithdrawPasswordPage.newPasswordPlaceholder')" class="form-input">
                    </div>
                </div>
                <div class="form-section">
                    <div class="section-title">
                        <div class="title-with-icon">
                            <span class="password-icon">✅</span>
                            <span>{{ t('changeWithdrawPasswordPage.confirmPassword') }}</span>
                        </div>
                    </div>
                    <div class="input-container">
                        <input type="password" v-model="formData.confirmPassword" :placeholder="t('changeWithdrawPasswordPage.confirmPasswordPlaceholder')" class="form-input">
                    </div>
                </div>
            </div>
            <div class="submit-button" @click="handleSubmit" :class="{ 'is-submitting': isSubmitting }">
                {{ isSubmitting ? t('common.submitting') : t('changeWithdrawPasswordPage.updateButton') }}
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import PageHeader from '@/components/PageHeader.vue'
import { changePayPassword } from '@/api'

const router = useRouter()
const { t } = useI18n()

const formData = ref({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
})

const isSubmitting = ref(false)



const handleSubmit = async () => {
    if (isSubmitting.value) {
        return
    }

    if (!formData.value.oldPassword) {
        ElMessage.warning(t('changeWithdrawPasswordPage.errorOldPassword'))
        return
    }

    if (!formData.value.newPassword) {
        ElMessage.warning(t('changeWithdrawPasswordPage.errorNewPassword'))
        return
    }

    if (!formData.value.confirmPassword) {
        ElMessage.warning(t('changeWithdrawPasswordPage.errorConfirmPassword'))
        return
    }

    if (formData.value.newPassword !== formData.value.confirmPassword) {
        ElMessage.warning(t('changeWithdrawPasswordPage.errorPasswordMismatch'))
        return
    }

    isSubmitting.value = true

    try {
        const response = await changePayPassword({
            old_pwd: formData.value.oldPassword,
            new_pwd: formData.value.newPassword
        })

        if (response.data.code === 200) {
            ElMessage.success(t('common.submitSuccess'))
            setTimeout(() => {
                router.push('/my')
            }, 2000)
        } else {
            ElMessage.error(response.data.msg || t('common.submitFailed'))
            isSubmitting.value = false
        }
    } catch (error) {
        console.error('修改提現密碼失敗:', error)
        ElMessage.error(t('common.submitFailed'))
        isSubmitting.value = false
    }
}
</script>

<style scoped>
.password-manage-container {
    background: var(--bg-secondary);
    min-height: 100vh;
    padding: 12px
}

.password-form {
    background: var(--card-bg);
    border-radius: 12px;
    padding: 24px;
    margin: 12px 0;
    box-shadow: var(--shadow-base)
}

.password-form .form-section {
    margin-bottom: 24px
}

.password-form .form-section:last-child {
    margin-bottom: 0
}

.password-form .form-section .section-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 12px
}

.password-form .form-section .section-title .title-with-icon {
    display: flex;
    align-items: center;
    gap: 8px
}

.password-form .form-section .section-title .title-with-icon .password-icon {
    font-size: 18px;
    color: #667eea
}

.password-form .form-section .input-container {
    background: var(--bg-tertiary);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    transition: all .3s ease;
    overflow: hidden
}

.password-form .form-section .input-container:focus-within {
    border-color: #667eea;
    background: var(--card-bg);
    box-shadow: 0 0 0 3px #667eea1a
}

.password-form .form-section .input-container .form-input {
    width: 100%;
    height: 50px;
    padding: 0 14px;
    font-size: 14px;
    color: var(--text-primary);
    background: transparent;
    border: none;
    outline: none
}

.password-form .form-section .input-container .form-input::placeholder {
    color: var(--text-placeholder)
}

.notice-text {
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.6;
    margin: 12px 0;
    padding: 0 6px
}

.submit-button {
    background: linear-gradient(135deg,#667eea,#764ba2);
    border-radius: 25px;
    padding: 18px 30px;
    margin: 24px 0;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    box-shadow: 0 4px 15px #667eea4d;
    transition: all .3s ease;
    cursor: pointer
}

.submit-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px #667eea66
}

.submit-button:active {
    transform: translateY(-1px)
}

.submit-button.is-submitting {
    opacity: 0.6;
    cursor: not-allowed
}

@media (max-width: 768px) {
    .password-manage-container {
        padding:8px
    }

    .password-form {
        padding: 20px;
        margin: 8px 0;
        border-radius: 8px
    }

    .password-form .form-section {
        margin-bottom: 20px
    }

    .password-form .form-section .section-title {
        font-size: 14px;
        margin-bottom: 10px
    }

    .password-form .form-section .section-title .title-with-icon .password-icon {
        font-size: 16px
    }

    .password-form .form-section .input-container {
        border-radius: 6px
    }

    .password-form .form-section .input-container .form-input {
        height: 44px;
        padding: 0 12px;
        font-size: 12px
    }

    .notice-text {
        font-size: 11px;
        margin: 8px 0;
        padding: 0 4px
    }

    .submit-button {
        padding: 16px 24px;
        margin: 20px 0;
        font-size: 16px;
        border-radius: 20px
    }
}

@media (max-width: 375px) {
    .password-form {
        padding:16px
    }

    .password-form .form-section {
        margin-bottom: 16px
    }

    .password-form .form-section .section-title {
        font-size: 13px;
        margin-bottom: 8px
    }

    .password-form .form-section .input-container .form-input {
        height: 40px;
        padding: 0 10px;
        font-size: 11px
    }

    .notice-text {
        font-size: 10px;
        margin: 6px 0
    }

    .submit-button {
        padding: 14px 20px;
        margin: 16px 0;
        font-size: 14px;
        border-radius: 18px
    }
}

</style>
